/** Bridge MobileNavDock (hamburger FAB) ↔ Media mobile topic sheet. */
export const MEDIA_MOBILE_NAV_TOGGLE = "woi-toggle-media-mobile-nav";
export const MEDIA_MOBILE_NAV_CLOSE = "woi-close-media-mobile-nav";
export const MEDIA_MOBILE_NAV_SYNC = "woi-media-mobile-nav-sync";

export type MediaMobileNavSyncDetail = { open: boolean };

/** After reactions (or other hub activity), tell the engagement bell to refetch `/api/media-hub/notifications`. */
export const MEDIA_HUB_NOTIFICATIONS_REFRESH = "woi-media-hub-notifications-refresh";

/** Desktop hub: URL hash — left column shows notifications (`MediaHubAppShell`) instead of the topic article list. */
export const MEDIA_HUB_NOTIFICATIONS_RAIL_HASH = "#woi-hub-notifications";

/**
 * Query flag (with {@link MEDIA_HUB_NOTIFICATIONS_RAIL_HASH}) so the notifications rail still opens if the hash
 * is dropped by a redirect or client navigation; dock “Notifications” sets this.
 */
export const MEDIA_HUB_NOTIFICATIONS_RAIL_QUERY_KEY = "hubNotifications";
export const MEDIA_HUB_NOTIFICATIONS_RAIL_QUERY_VALUE = "1";

const MEDIA_HUB_SINGLE_SEGMENT_RESERVED = new Set(["account", "submit", "review", "guidelines"]);

/**
 * True for `/media` or `/media/:articleSlug` handled by the main hub `<Media />` route
 * (excludes `/media/account`, `/media/submit`, `/media/review`, `/media/guidelines`, etc.).
 */
export function isMediaHubFeedOrArticlePath(pathname: string): boolean {
  if (pathname === "/media") return true;
  if (!pathname.startsWith("/media/")) return false;
  const rest = pathname.slice("/media/".length);
  if (!rest || rest.includes("/")) return false;
  const first = rest.split("/")[0] ?? "";
  return !MEDIA_HUB_SINGLE_SEGMENT_RESERVED.has(first);
}
